module.exports = "../dist/frontend/icons/cards/section/globe.svg?c7700edd91cb703d922fe1b396da3624";